<template>

    <div class="card mb-3">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <p class="font-weight-bold text-center">
                        <i class="bi bi-lock-fill"></i>
                        {{ __('messages.purchases_safe', [siteConfig.appName]) }}
                    </p>

                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <span class="icon-bank-brand icon-brand-pci"></span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

const site = window.__pt.settings.site;

export default {
    data() {
        return {
            data: {},
            siteConfig: site
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>
